export default "__VITE_ASSET__WB$1uOEe__"